import { useNavigate } from "react-router-dom";
import TableFilter from "./tableFilter";
import { useEffect } from "react";

function HubSetup() {
  const navigate = useNavigate();
  const hubId = localStorage.getItem("hubId");

  useEffect(() => {
    if (hubId) {
      navigate(`/community-setup/details/${hubId}`);
    }
  }, [hubId, navigate]);
  return (
    <>
      <div className="content-wrapper">
        <div
          className="content-heading d-flex
                          justify-content-between"
        >
          <div>Communities</div>
          <div>
            <button
              className="btn btn-labeled btn-success"
              type="button"
              style={{ fontSize: "17px" }}
              onClick={() => navigate("/community-setup/new")}
            >
              <span className="btn-label">
                <em className="fas fa-plus"></em>
              </span>
              New Community
            </button>
          </div>
        </div>
        <TableFilter />
      </div>
    </>
  );
}

export default HubSetup;
